import { render, staticRenderFns } from "./ConstructionTaskNewPage.vue?vue&type=template&id=996bb9bc&"
import script from "./ConstructionTaskNewPage.vue?vue&type=script&lang=ts&"
export * from "./ConstructionTaskNewPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports